import React from "react";
import { useUser } from "../../context/contextAPI";
import { Helmet } from "react-helmet";

function UserProfil() {
  const { user } = useUser();

  return (
    <div className="h-screen">
      <Helmet>
        <title>Profil</title>
      </Helmet>
      <h1 className="poppins-bold text-3xl md:text-5xl text-gray-900 text-center">
        Mon profil
      </h1>
      <div className="flex items-center mt-5 md:mt-16 w-full justify-center">
        {user && (
          <div className="max-w-full md:max-w-4xl">
            <div className="bg-white shadow-xl rounded-2xl py-3">
              <div className="py-2 px-4">
                <h3 className="text-center text-3xl md:text-4xl text-gray-900 poppins-bold leading-8">
                  {user.firstName} {user.lastName}
                </h3>
                <table className="text-sm sm:text-base mt-4 mb-2">
                  <tbody>
                    <tr>
                      <td className="px-2 py-2 text-gray-600 poppins-semibold text-xs sm:text-sm">
                        Email
                      </td>
                      <td className="text-gray-500 px-2 py-2 text-xs sm:text-sm">: {user.email}</td>
                    </tr>
                    <tr>
                      <td className="px-2 py-2 text-gray-600 poppins-semibold text-xs sm:text-sm">
                        Phone
                      </td>
                      <td className="text-gray-500 px-2 py-2 text-xs sm:text-sm">: {user.phone}</td>
                    </tr>
                    <tr>
                      <td className="px-2 py-2 text-gray-600 poppins-semibold text-xs sm:text-sm">
                        Adresse
                      </td>
                      <td className="text-gray-500 px-2 py-2 text-xs sm:text-sm">: {user.address}</td>
                    </tr>
                    <tr>
                      <td className="px-2 py-2 text-gray-600 poppins-semibold text-xs sm:text-sm">
                        Ville
                      </td>
                      <td className="text-gray-500 px-2 py-2 text-xs sm:text-sm">: {user.city}</td>
                    </tr>
                    <tr>
                      <td className="px-2 py-2 text-gray-600 poppins-semibold text-xs sm:text-sm">
                        Pays
                      </td>
                      <td className="text-gray-500 px-2 py-2 text-xs sm:text-sm">: {user.country}</td>
                    </tr>
                    <tr>
                      <td className="px-2 py-2 text-gray-600 poppins-semibold text-xs sm:text-sm">
                        Nombre de filleul
                      </td>
                      {user.referrals.length > 1 ? (
                        <td className="text-gray-500 px-2 py-2 text-xs sm:text-sm">: {" "}
                          {user.referrals.length} utilisateurs
                        </td>
                      ) : (
                        <td className="text-gray-500 px-2 py-2 text-xs sm:text-sm">: {" "}
                          {user.referrals.length} utilisateur
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>

                <div className="text-center my-3">
                  <button
                    className="py-2 bg-black w-full text-white transition-all duration-300 hover:bg-pink-600 poppins-bold rounded-full mt-5"
                  >
                    Modifier votre profil
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserProfil;
